<template>
  <div class="scroll-container" :class="[containerClassName, emptyClassName]" ref="scroll">
    <div class="scroll-wrapper">
      <GuideEntry v-if="ticketType === 1"></GuideEntry>
      <EmptyPage v-show="ticketList.length === 0"></EmptyPage>
      <TicketItem
        v-for="(item, index) in ticketList"
        :ticketType="ticketType"
        :ticketInfo="item"
        @emit_showDialog="emit_showDialog"
        :key="index"></TicketItem>
      <div class="after-loading" v-show="ticketList.length > 0">
        {{bottomText}}
      </div>
    </div>
    <div class="loading" v-show="loading"></div>
    <MDialog
      v-bind="{
                model: dialogModel,
                isShow: isDialogShow,
                content: dialogContent,
                btnTrueText: dialogConfirmText
            }"
      @emit_close="emit_closeDialog"
      @emit_ok="emit_confirm"
    ></MDialog>
  </div>
</template>

<script>
  import TicketItem from './TicketItem';
  import GuideEntry from './GuideEntry';
  import EmptyPage from './EmptyPage';
  import MDialog from '@/components/MDialog';

  import BScroll from 'better-scroll';

  import {queryTickets} from '@/api';

  export default {
    components: {
      TicketItem,
      GuideEntry,
      EmptyPage,
      MDialog
    },
    props: {
      ticketType: {
        type: Number
      },
      refresh: {
        type: Boolean
      }
    },
    data() {
      return {
        pageIndex: 1,
        pageSize: 10,
        ticketList: [],
        loading: true,
        bottomText: ' ',
        isDialogShow: false,
        dialogModel: 'confirm', // confirm-确认弹框（取消与确定按钮）  alert-提示弹框（确定按钮）
        dialogContent: '',
        dialogConfirmText: '确定'
      };
    },
    watch: {
      'refresh': function (refresh) {
        const _this = this;
        if (refresh && this.ticketType === 1) {
          _this.pageIndex = 1;
          _this.ticketList = [];
          _this._queryTickets(1);
        }
      },
      // 弹框出现时禁止滑动
      'isDialogShow': function (bool) {
        if (bool) {
          this.scroll && this.scroll.disable();
        } else {
          this.scroll && this.scroll.enable();
        }
      }
    },
    computed: {
      containerClassName() {
        let className = '';
        switch(this.ticketType){
          case 1:
            className = 'unuse';
            break;
          case 2:
            className = 'used';
            break;
          case 3:
            className = 'expired';
            break;
        }
        return className;
      },
      emptyClassName() {
        return this.ticketList.length === 0 ? 'empty-container' : '';
      }
    },
    created() {
      const _this = this;
      _this._initScroll();
      _this._queryTickets(_this.pageIndex);
    },
    activated () {
      const _this = this;

      // 从其他tab页切回时让scroll可用，并且刷新scroll
      if (_this.scroll) {
        _this.scroll.enable();
        _this.scroll.refresh();
      }
    },
    deactivated () {
      this.scroll && this.scroll.disable();
    },
    methods: {
      _initScroll() {
        const _this = this;
        _this.$nextTick(() => {
          _this.scroll = new BScroll(this.$refs.scroll, {
            click: true,
            pullUpLoad: true,
            stopPropagation: true,
            probeType: 3
           })
          _this.scroll.on('pullingUp', () => {
            if (_this.bottomText === '没有更多数据了') {
              return;
            }
            _this.bottomText = '正在加载数据.....';
            _this._queryTickets(_this.pageIndex + 1);
          });
        });
      },
      _queryTickets(pageIndex) {
        const _this = this;
        const {pageSize, ticketType} = this;
        _this.loading = true;
        queryTickets(pageIndex, pageSize, ticketType).then(res => {
          _this.loading = false;
          _this.scroll.finishPullUp();
          const data = res.data;
          const {retCode} = data;
          if (retCode === 0) {
            const {unUseCount, expireCount, usedCount, ticketList} = data;
            _this.$emit('emit_setCount', {
              unUseCount,
              expireCount,
              usedCount
            });
            if (ticketList.length > 0) {
              _this.bottomText = ' ';
              _this.ticketList = _this.ticketList.concat(ticketList);
              _this.pageIndex = pageIndex;
              _this.$nextTick(() => {
                // 只有在scroll实例可用时才刷新，防止出现在请求数据时切换tab导致的切回当前tab时scroll失效的问题
                _this.scroll.enabled && _this.scroll.refresh();
              });
            } else {
              _this.bottomText = '没有更多数据了';
            }
          }
        }).catch(() => {
          _this.loading = false;
        });
      },
      // 显示优惠券提示弹框
      emit_showDialog (ticketInfo) {
        const _this = this;
        const {useChannel, useChannelText} = ticketInfo;

        if (useChannel.indexOf('4') >= 0) {
          _this.dialogContent = `此券${useChannelText}`;
          _this.dialogModel = 'confirm';
          _this.dialogConfirmText = '去下载';
          _this.isDialogShow = true;
        } else {
          _this.dialogContent = `此券${useChannelText}`;
          _this.dialogModel = 'alert';
          _this.dialogConfirmText = '确定';
          _this.isDialogShow = true;
        }
      },
      // 关闭优惠券提示弹框
      emit_closeDialog() {
        this.isDialogShow = false;
      },
      emit_confirm () {
        // 单纯弹框提示，不跳转下载页面
        if (this.dialogModel === 'alert') {
          return;
        }
        // 引导下载app
        window.location.href = '//m.secoo.com/d/secoo';
      }
    }
  };
</script>

<style lang="scss" scoped>
.after-loading {
  text-align: center;
  font-size: toRem(24);
}
</style>



// WEBPACK FOOTER //
// src/pages/TicketList/components/ScrollItem.vue